// extracted by mini-css-extract-plugin
export default {"container":"agencia_container__QzoR0","descripcion":"agencia_descripcion__pppsN"};